import { isLocalHost } from 'utils/env';
// If we are in dev environment, define global.mw
if (isLocalHost()) {
    window.mw = {
        config: new Map([
            ['wgArticleId', '13'],
            ['wgServer', 'https://harrypotter.sandbox-dpaluch.fandom.com'],
            ['isDarkTheme', true],
            ['wgTitle', 'Newton Scamander'],
        ]),
    };
}
function assertMwExists() {
    if (!window.mw) {
        throw new Error('window.mw is not initialized');
    }
}
export function getArticleId() {
    assertMwExists();
    return window.mw.config.get('wgArticleId');
}
export function getServerAddress() {
    assertMwExists();
    return window.mw.config.get('wgServer');
}
export function getIsDarkTheme() {
    assertMwExists();
    return window.mw.config.get('isDarkTheme');
}
export function getArticleTitle() {
    assertMwExists();
    return window.mw.config.get('wgTitle');
}
